import React from 'react';
import styled from 'styled-components';
import * as CONSTANTS from '../constants';
import Link from 'next/link';
import Title from '../components/Title';
import EntryInfo from '../components/EntryInfo';
import Entries from '../components/Entries';
import SubmitSiteButton from '../components/SubmitSiteButton';
import fetch from 'isomorphic-unfetch';
import { ModalContext } from '../context/modal';
import Head from 'next/head';
import { logEvent } from '../utils/analytics';
import Router from 'next/router';

const Screenshot = styled.img`
	margin: 10px auto 0 auto;
	display: block;
	border-radius: 3px;
	border: 1px solid #eee;

	@media (max-width: 770px) {
    width: 100%;
  };

	@media (max-width: 741px) {
    width: 85%;
  };
`;

const DetailModal = styled.div`
	display: table;
	margin: 0 auto;
`;

const SeeMore = styled.div`
	padding: 50px 0 30px 0;
	margin: 60px 0 60px 0;
	border-top: 4px solid ${CONSTANTS.lightGray};
	width: 100%;
`;

const SeeMoreTitle = styled.h1`
	margin: 0;
	text-align: center;
	font-size: 24px;
	font-weight: 200;
`;

const CTA = styled.a`
	font-size: ${CONSTANTS.ctaText};
	font-weight: 200;
	text-align: center;
	display: table;
	padding: 8px 30px;
	color: ${CONSTANTS.white};
	background-color: ${CONSTANTS.darkGray};
	margin: 30px auto 0 auto;
	border-radius: 3px;
	margin: 30px auto 0 auto;

	&:hover {
		background-color: ${CONSTANTS.fakeCtaOpacity};
	}
`;

const Description = styled.span`
	color: ${CONSTANTS.mediumGray};
	font-size: 16px;
	display: block;
	text-align: center;
	padding: 0 30px;
	margin: 30px auto 0 auto;
`;

const Wrapper = styled.div`
	${SeeMore} {
		${props => (props.darkMode === true ? `border-color: #242329` : '')}
	}

	${SeeMoreTitle} {
		${props => (props.darkMode === true ? `color: #fff` : '')}
	}

	${CTA} {
		${props => (props.darkMode === true ? `color: #fff;background-color: #1a1a1a; &:hover{background-color: #141414;}` : '')}
	}

	${Screenshot} {
		${props => (props.darkMode === true ? `border-color: #242329` : '')}
	}
`;

export default class Sites extends React.Component {
static async getInitialProps({ query }) {

	const feedData = await fetch(`${CONSTANTS.API_URL}?entry=${query.slug}`);

	let data;
	
	try {
		data = await feedData.json();
	} catch (error) {
		data = null;
	}

	return { entry: data }
}

constructor(props) {
	super(props);
}

componentDidMount() {
	if(this.props.entry === null) {
		const href = '/error';
    const as = href;
		Router.push(href, as, { shallow: true });
	}
}

render () {
	let tags = this.props.entry ? this.props.entry.tags.split(',') : [];
	let shades = this.props.entry ? this.props.entry.shades.split(',') : [];
	
	return (
		this.props.entry ? (
			<React.Fragment>
				<Head>
					<title>{this.props.entry.title} - Featured on SiteSee</title>
					<meta name="description" content={`${this.props.entry.title}, featured on SiteSee - a curated gallery of beautiful, modern websites.`}></meta>
					<meta property="og:locale" content="en_US" />
					<meta property="og:type" content="website" />
					<meta property="og:site_name" content="SiteSee" />
					<meta property="og:title" content={this.props.entry.title} />
					<meta property="og:url" content={`https://sitesee.co${this.props.entry.inboundUrl}`} />
					<meta property="og:image" content={this.props.entry.screenshot} />
					<meta property="og:description" content="Featured on SiteSee - a curated gallery of beautiful, modern websites." />
					<meta name="twitter:card" content="summary_large_image" />
					<meta name="twitter:site" content="@siteseegallery" />
					<meta name="twitter:title" content="SiteSee" />
					<meta name="twitter:description" content="A curated gallery of beautiful, modern websites." />
					<meta name="twitter:image" content="https://d3alngem7je9z2.cloudfront.net/sitesee_banner.png" />
				</Head>
				<Wrapper darkMode={this.context.darkMode}>
					<Description>SiteSee is a curated gallery of beautiful, modern websites.</Description>
					<Title title={this.props.entry.title} showBreadcrumb />
					<DetailModal>
						<Screenshot src={this.props.entry.screenshot} alt="Screenshot" />
						<EntryInfo shades={shades} tags={tags} title={this.props.entry.title} inboundUrl={this.props.entry.inboundUrl} />
						<CTA href={this.props.entry.outboundUrl} target="_blank" aria-label={this.props.entry.urlTitle} rel="noopener noreferrer" onClick={(e) => logEvent('details page outbound CTA', 'click')}>{this.props.entry.urlTitle} →</CTA>
						<SubmitSiteButton tabIndex="0" text="Want to submit a site?" />
					</DetailModal>
					<SeeMore>
						<SeeMoreTitle>More inspiration from SiteSee</SeeMoreTitle>
						<Entries entries={this.props.entry.moreEntries} origin="sites" />
						<Link href="/">
							<CTA href="/" onClick={(e) => logEvent('details page | explore the gallery CTA', 'click')}>Explore the full gallery</CTA>
						</Link>
					</SeeMore>
				</Wrapper>
			</React.Fragment>
		) : null
	);
}
}

Sites.contextType = ModalContext;
